'use client';
import { __rest, __assign } from '../_virtual/_tslib.js';
import { Trigger as $409067139f391064$export$41fb9f06171c75f4, Content as $409067139f391064$export$7c6e2c02157bb7d2, Root as $409067139f391064$export$be92b6f5f03c0fe9 } from '../external/@radix-ui/react-collapsible/dist/index.module.js';
import { Slot as $5e63c961fc1ce211$export$8c6ed5c666ac1360 } from '../external/@radix-ui/react-slot/dist/index.js';
import classNames from '../external/classnames/index.js';
import React__default from 'react';
import styles from './collapsible.module.css.js';

var Chevron = React__default.forwardRef(function CollapsibleChevron(_a, ref) {
    var className = _a.className, otherProps = __rest(_a, ["className"]);
    return React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, __assign({ ref: ref, className: classNames(className, styles.chevron) }, otherProps));
});
var Trigger = React__default.forwardRef(function Trigger(_a, ref) {
    var className = _a.className, children = _a.children; _a.placeholder; var otherProps = __rest(_a, ["className", "children", "placeholder"]);
    return (React__default.createElement($409067139f391064$export$41fb9f06171c75f4, __assign({ className: classNames(className, styles.trigger), ref: ref }, otherProps), children));
});
var Content = React__default.forwardRef(function Content(_a, ref) {
    var className = _a.className, children = _a.children, otherProps = __rest(_a, ["className", "children"]);
    return (React__default.createElement($409067139f391064$export$7c6e2c02157bb7d2, __assign({ className: classNames(className, styles.content), ref: ref }, otherProps), children));
});
var Root = $409067139f391064$export$be92b6f5f03c0fe9;
var Collapsible = {
    Root: Root,
    Trigger: Trigger,
    Content: Content,
    Chevron: Chevron,
};

export { Chevron, Collapsible, Content, Root, Trigger };
